import React, { useEffect, useState } from "react";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import { MaterialReactTable } from "material-react-table";
import UserInfoModal from "components/UserInfoModal/UserInfoModal";
import { avtar } from "utils/images";
import DateFilter from "components/DateFilter/DateFilter";
import SelectFilter from "components/SelectFilter/SelectFilter";
import { useLocation } from "react-router-dom";
import Modal from "components/daisyUiMsgModal/Modal";
import CustomerInfoModal from "components/CustomerInfoModal/CustomerInfoModal";
import AirticketInvoiceModal from "components/InvoiceModal/AirticketInvoiceModal";
import InvoiceModal from "components/InvoiceModal/InvoiceModal";
import MiscInvoiceModal from "components/InvoiceModal/MiscInvoiceModal";
import GoBackButton from "components/GoBackButton/GoBackButton";
export default function InvoiceHistory({}) {
  const location = useLocation();

  const reversedHistory = location.state;
  const history = Array.isArray(reversedHistory)
    ? [...reversedHistory].reverse()
    : [];

  console.log(history, "history");

  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [invocieData, setInvoiceData] = useState();
  const [customerModalData, setCustomerModalData] = useState({});
  const [itinerary, setItinerary] = useState(""); // State for modal
  const [isInsourenceModalOpen, setIsInsourenceModalOpen] = useState(false);
  const [insourenceData, setInsourenceData] = useState();
  const [isLandPackageModalOpen, setIsLandPackageModalOpen] = useState(false);
  const [landPackageData, setLandPackageData] = useState();
  const [isMiscModalOpen, setIsMiscModalOpen] = useState(false);
  const [miscData, setMiscData] = useState();
  const [isCruiseModalOpen, setIsCruiseModalOpen] = useState(false);
  const [cruiseData, setCruiseData] = useState();
  const [isHotelModalOpen, setIsHotelModalOpen] = useState(false);
  const [hotelData, setHotelData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [createdByData, setCreatedByData] = useState([]);
  const [createdById, setCreatedById] = useState(null);
  const [updatedById, setUpdatedById] = useState(null);
  const [createdAtFilterDate, setCreatedAtFilterDate] = useState("");
  const [updatedFilterDate, setUpdatedFilterDate] = useState("");

  console.log(history, "history");

  const [isLoading, setIsLoading] = useState(true);

  const handleOpenModal = (assignedUser) => {
    setUserProfile(assignedUser);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setUserProfile({}); // Reset user profile on close
  };

  const handleModalOpen = (data) => {
    setItinerary(data); // Set the travel experience text
    setIsInfoModalOpen(true); // Open the modal
  };
  const handleModalClose = () => {
    setIsInfoModalOpen(false); // Close the modal
    setItinerary(""); // Reset the travel experience
  };

  const handleCustomerModalOpen = (data) => {
    setCustomerModalData(data); // Set the travel experience text
    setIsCustomerModalOpen(true); // Open the modal
  };
  const handleCustomerModalClose = () => {
    setIsCustomerModalOpen(false); // Close the modal
    setCustomerModalData(""); // Reset the travel experience
  };

  const handleInvocieModalOpen = (data) => {
    setInvoiceData(data); // Set the travel experience text
    setIsInvoiceModalOpen(true); // Open the modal
  };
  const handleInvoiceModalClose = () => {
    setIsInvoiceModalOpen(false); // Close the modal
    setInvoiceData(""); // Reset the travel experience
  };

  const handleInsouranceModalClose = () => {
    setIsInsourenceModalOpen(false); // Close the modal
    setInsourenceData(""); // Reset the travel experience
  };

  const handleHotelModalClose = () => {
    setIsHotelModalOpen(false); // Close the modal
    setHotelData(""); // Reset the travel experience
  };

  const handleLandPackageModalClose = () => {
    setIsLandPackageModalOpen(false); // Close the modal
    setLandPackageData(""); // Reset the travel experience
  };

  const handleCruiseModalClose = () => {
    setIsCruiseModalOpen(false); // Close the modal
    setCruiseData(""); // Reset the travel experience
  };

  const handleMiscModalClose = () => {
    setIsMiscModalOpen(false); // Close the modal
    setMiscData(""); // Reset the travel experience
  };

  // Column definitions for the table
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "invoice_number",
        header: "Invoice Number",
        enableColumnFilter: false, // Disable filter for this column
      },
      {
        accessorKey: "fromAirport",
        header: "Travel From",
        enableColumnFilter: false,
        Cell: ({ cell }) => cell?.getValue()?.name || "N/A",
      },
      {
        accessorKey: "toAirport",
        header: "Travel To",
        enableColumnFilter: false,
        Cell: ({ cell }) => cell?.getValue()?.name || "N/A",
      },
      {
        accessorKey: "airticket.airline_name",
        header: "Airline Name",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <p>
            {row.original?.airLine?.airline_name
              ? row.original?.airLine?.airline_name
              : "Empty"}
          </p>
        ),
      },
      {
        accessorKey: "customer_details.full_name",
        header: "Full Name",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => <p>{row.original.customer_details.full_name}</p>,
      },
      {
        accessorKey: "airticket",
        header: "Air Ticket",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.airticket_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.airticket,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    gds_locator: row.original.gds_locator,
                    gds_type: row.original.gds_type,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    fromAirport: row.original.fromAirport,
                    toAirport: row.original.toAirport,
                    other_remarks: row.original.other_remarks,
                    ticket_number: row.original.ticket_number,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    itinerary: row.original.itinerary,
                    created_at: row.original.created_at,
                    supplier: row.original.supplier,
                    airLine: row.original?.airLine,
                    mco: row.original?.mco,
                    status: row.original?.status,
                  };
                  handleInvocieModalOpen(data);
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "insurance",
        header: "Insurance",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.insurance_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.insurance,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    other_remarks: row.original.other_remarks,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                  };
                  setInsourenceData(data);
                  setIsInsourenceModalOpen(true);
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "land_package",
        header: "Land Package",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.land_package_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.land_package,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    other_remarks: row.original.other_remarks,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                  };
                  setLandPackageData(data);
                  setIsLandPackageModalOpen(true);
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "cruise",
        header: "Cruise",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.cruise_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.cruise,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    other_remarks: row.original.other_remarks,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                  };
                  setCruiseData(data);
                  setIsCruiseModalOpen(true);
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "hotel",
        header: "Hotel",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.hotel_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.hotel,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    other_remarks: row.original.other_remarks,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                  };
                  setHotelData(data); // Set the travel experience text
                  setIsHotelModalOpen(true); // Open the modal
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "misc",
        header: "Misc",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.misc_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.misc,
                    sales_agents: row.original.sales_agents,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                  };
                  setMiscData(data); // Set the travel experience text
                  setIsMiscModalOpen(true); // Open the modal
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "customer_details",
        header: "Customer Details",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <button
            className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
            onClick={() =>
              handleCustomerModalOpen(row.original.customer_details)
            }
          >
            Open
          </button>
        ),
      },
      {
        accessorKey: "itinerary",
        header: "Itinerary",
        Cell: ({ row }) => (
          <div>
            {row.original.itinerary ? (
              <button
                className="btn btn-sm border border-orange-500 bg-orange-500 text-white outline-none hover:bg-white hover:text-orange-500"
                onClick={() => handleModalOpen(row.original.itinerary)}
              >
                Open
              </button>
            ) : (
              <p>Empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "created_at", // Adjust this to match your actual data structure
        header: "Created Date",
        filterVariant: "select",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <DateFilter
            column={column}
            selectedDate={createdAtFilterDate}
            setSelectedDate={setCreatedAtFilterDate}
          />
        ),

        Cell: ({ cell }) => {
          const createdAt = new Date(cell.getValue());
          const date = createdAt.toLocaleDateString(); // Get the date portion
          const time = createdAt.toLocaleTimeString(); // Get the time portion

          return (
            <div className="flex flex-col">
              <p
                className="font-semibold
              "
              >
                Date: <span className="font-light">{date}</span>
              </p>{" "}
              {/* Display the date */}
              <p
                className="font-semibold
              "
              >
                Time: <span className="font-light">{time}</span>
              </p>{" "}
              {/* Display the time */}
            </div>
          );
        },
      },
      {
        accessorKey: "updated_at", // Adjust this to match your actual data structure
        header: "Updated Date",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <DateFilter
            column={column}
            selectedDate={updatedFilterDate}
            setSelectedDate={setUpdatedFilterDate}
          />
        ),
        Cell: ({ cell }) => {
          const updatedAt = new Date(cell.getValue());
          const date = updatedAt.toLocaleDateString(); // Get the date portion
          const time = updatedAt.toLocaleTimeString(); // Get the time portion

          return (
            <div className="flex flex-col">
              <p
                className="font-semibold
              "
              >
                Date: <span className="font-light">{date}</span>
              </p>{" "}
              {/* Display the date */}
              <p
                className="font-semibold
              "
              >
                Time: <span className="font-light">{time}</span>
              </p>{" "}
              {/* Display the time */}
            </div>
          );
        },
      },
      {
        accessorKey: "sales_agents",
        header: "Sales Agent",
        Filter: ({ column }) => (
          <SelectFilter
            options={createdByData}
            selectedId={createdById}
            setSelectedId={setCreatedById}
            column={column}
            placeholder="created By..."
          />
        ),
        Cell: ({ cell }) => {
          const assignedBy = cell.getValue();

          return (
            <div className="flex items-center gap-2">
              <div className="tooltip" data-tip="Profile">
                <img
                  onClick={() => handleOpenModal(assignedBy)} // Wrap in an arrow function
                  className="h-10 w-10 cursor-pointer rounded-full"
                  src={assignedBy?.full_path}
                  alt={assignedBy?.name}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = avtar; // Default avatar
                  }}
                />
              </div>
              <div>
                <p>{assignedBy?.name}</p>
                <p>{assignedBy?.phone_no}</p>
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "updatedByUser",
        header: "updated By",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <SelectFilter
            options={createdByData}
            selectedId={updatedById}
            setSelectedId={setUpdatedById}
            column={column}
            placeholder="Updated By..."
          />
        ),
        Cell: ({ cell }) => {
          const assignedBy = cell.getValue();
          return (
            <div className="flex items-center gap-2">
              {assignedBy ? (
                <>
                  <div className="tooltip" data-tip="Profile">
                    <img
                      onClick={() => handleOpenModal(assignedBy)} // Wrap in an arrow function for passing data
                      className="h-10 w-10 cursor-pointer rounded-full"
                      src={assignedBy?.full_path}
                      alt={assignedBy?.name || "User Avatar"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = avtar; // Default avatar
                      }}
                    />
                  </div>
                  <div>
                    <p>{assignedBy?.name}</p>
                    <p>{assignedBy?.phone_no}</p>
                  </div>
                </>
              ) : (
                "N/A"
              )}
            </div>
          );
        },
      },
    ],
    [history]
  );

  useEffect(() => {
    if (history) {
      setIsLoading(false);
    }
  }, [history]);
  return (
    <section className="mx-2">
      <ScrollToTopOnRouteChange />

      {/* Modal for User Info */}
      <div className="">
        {isModalOpen && (
          <UserInfoModal user={userProfile} onClose={handleCloseModal} />
        )}
      </div>
      <div className={`h-[100vh] bg-white dark:bg-gray-900`}>
        <div className="flex items-center justify-between p-5 font-semibold">
          <h2 className="text-3xl text-gray-900 dark:text-[#ff4e41]">
            History
          </h2>
          <GoBackButton />
        </div>
        <div>
          {history.map((e, index) => {
            <h2 className="my-5 text-2xl" key={index}>
              Search Enquiry History {e?.parent_id}
            </h2>;
          })}
        </div>
        <MaterialReactTable
          columns={columns}
          data={history}
          state={{
            isLoading,
          }} // Use both states here
          enableColumnFilters={false}
          initialState={{
            showColumnFilters: false,
          }}
          enableSorting={false}
          enableColumnOrdering={false}
          enablePagination={false}
          manualPagination
          isLoading={isLoading}
          enableGlobalFilter={false} // Keep this true to allow global filtering
        />
      </div>
      {/* DaisyUI Modal */}
      {isInfoModalOpen && (
        <Modal
          heading="Itinerary"
          paragraph={itinerary}
          close={handleModalClose}
        />
      )}

      {/* customer Data modal */}
      {isCustomerModalOpen && (
        <CustomerInfoModal
          data={customerModalData}
          close={handleCustomerModalClose}
        />
      )}

      {/* Invoice Data modal */}
      {isInvoiceModalOpen && (
        <AirticketInvoiceModal
          data={invocieData}
          close={handleInvoiceModalClose}
          history={true}
        />
      )}

      {/* Invoice Data modal */}
      {isInsourenceModalOpen && (
        <InvoiceModal
          data={insourenceData}
          close={handleInsouranceModalClose}
        />
      )}

      {isHotelModalOpen && (
        <InvoiceModal
          data={hotelData}
          close={handleHotelModalClose}
          hotel={true}
        />
      )}

      {isLandPackageModalOpen && (
        <InvoiceModal
          data={landPackageData}
          close={handleLandPackageModalClose}
          landPackage={true}
        />
      )}

      {isCruiseModalOpen && (
        <InvoiceModal
          data={cruiseData}
          close={handleCruiseModalClose}
          cruise={true}
        />
      )}
      {isMiscModalOpen && (
        <MiscInvoiceModal data={miscData} close={handleMiscModalClose} />
      )}
    </section>
  );
}
